module.exports = __webpack_public_path__ + "Icono_Editar_512px.png";